"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fmoneySpace = fmoneySpace;
const lang_1 = require("./lang");
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param forcezeros czy zachować zera ,00
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function fmoneySpace(value, forcezeros, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
precision = 2, lang) {
    let ext;
    const lng = lang || (this === null || this === void 0 ? void 0 : this.lang) || lang_1.defaultLang.current;
    if (typeof value !== 'string') {
        // ext = fmoney(value, forcezeros, precision, lng);
        return lng.formatSpaceNumber(value);
    }
    else {
        ext = value;
    }
    const sep = lng.decimalSeparator;
    const gsep = lng.groupSeparator;
    const parts = ext.split(sep);
    let result = '';
    const partsLength = parts[0].length - 1;
    for (let i = 0; i <= partsLength; i++) {
        result = parts[0][partsLength - i] + result;
        if (i < partsLength && (i === 2 || i === 5 || i === 8 || i === 11)) {
            result = gsep + result;
        }
    }
    if (parts.length > 1) {
        return result + sep + parts[1];
    }
    else {
        return result;
    }
}
//# sourceMappingURL=fmoneySpace.js.map